import { render } from "./FormPubPer.vue?vue&type=template&id=12000e91&scoped=true"
import script from "./FormPubPer.vue?vue&type=script&lang=js"
export * from "./FormPubPer.vue?vue&type=script&lang=js"

import "./FormPubPer.vue?vue&type=style&index=0&id=12000e91&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-12000e91"

export default script